import {Scene, Sprite} from 'spritejs'
import random from '../random'
import debounce from 'lodash.debounce'

function banner (selector = '#js-banner') {

  let $element = document.querySelector(selector)
  if (!$element) {
    return null
  }
  let height = 300
  let width = window.innerWidth
  if (width < 768) {
    height = 150
  }
  // const scene = new Scene(selector, {viewport: ['auto', 'auto'], resolution: [width, height]})
  const scene = new Scene(selector, width, height)

  let layer = scene.layer()

  const sky = new Sprite(require('../../img/banner/sky.png'))
  sky.attr({
    pos: [0, -30],
  })
  layer.appendChild(sky)

  const roadWithStop = new Sprite(require('../../img/banner/road_with_stop.png'))
  roadWithStop.attr({
    pos: [0, 0],
    size: [width * 2, height],
    zIndex: 1
  })
  layer.appendChild(roadWithStop)
  roadWithStop.animate([{x: -width * .5}], {
    duration: 10000,
    iterations: Infinity
  })

  const stop = new Sprite(require('../../img/banner/stop.png'))
  let stopRatio = 1.67
  let stopWidth = width > 768 ? 250 : 150
  let roadSpace = width > 768 ? 30 : 15
  stop.attr({
    pos: [width, height - stopWidth / stopRatio - roadSpace],
    size: [stopWidth, stopWidth / stopRatio],
    zIndex: 1
  })
  layer.appendChild(stop)
  // should animate with same speed as road
  stop.animate([{x: 0}], {
    duration: 20000,
    iterations: Infinity
  })


  const bus = new Sprite(require('../../img/banner/bus.png'))
  let ratio = 2.5
  let busWidth = width > 768 ? 250 : 200
  bus.attr({
    zIndex: 2,
    pos: [-busWidth, height - busWidth / ratio + 20],
    size: [busWidth, busWidth / ratio]
    // pos: [100, 220],
    // size: [250, 100],
  })
  layer.appendChild(bus)
  bus.animate([{x: width}], {
    duration: 20000 + random(5, 15) * 1000,
    easing: 'ease-in-out',
    iterations: Infinity,
  })


  const busReverse = new Sprite(require('../../img/banner/bus_reverse.png'))
  ratio = 2.67
  busWidth = width > 768 ? 240 : 190
  busReverse.attr({
    zIndex: 1,
    pos: [width, height - busWidth / ratio - 10],
    size: [busWidth, busWidth / ratio],

  })
  layer.appendChild(busReverse)
  busReverse.animate([{x: -width}], {
    delay: random(5, 10) * 1000,
    duration: 20000 + random(5, 15) * 1000,
    easing: 'ease-in-out',
    iterations: Infinity,
  })

  const cloudLight = new Sprite(require('../../img/banner/clouds_light.png'))
  cloudLight.attr({
    size: [width, height],
    pos: [-width * .5, 0],
  })
  layer.appendChild(cloudLight)
  cloudLight.animate([{x: width}], {
    duration: 108000,
    easing: 'linear',
    iterations: Infinity,
  })

  const cloudDark = new Sprite(require('../../img/banner/clouds_dark.png'))
  cloudDark.attr({
    size: [width, height],
    pos: [0, 0],
    opacity: .7
  })
  layer.appendChild(cloudDark)
  cloudDark.animate([{x: -width}], {
    duration: 45000,
    easing: 'linear',
    iterations: Infinity,
  })

  return scene
}

export default banner



// WEBPACK FOOTER //
// ./resources/assets/js/module/app.banner.js